import MemberEntryGroup, {
  MemberGroup,
} from "app/containers/Features/components/EffortActual/MemberEntryGroup";
import { IEffortActual } from "app/containers/Features/containers/Ticket/types";
import { ISelectedTicketDetails } from "app/containers/Features/containers/TimeSheet/types";
import React, { FC, useMemo } from "react";

const TimeEntryItem: FC<{
  effortActual: IEffortActual[];
  selectedTicketDetails: ISelectedTicketDetails;
}> = ({ effortActual, selectedTicketDetails }) => {
  // Group effortActual by memberId
  const groupedByMember = useMemo(() => {
    const map = new Map<string, IEffortActual[]>();

    effortActual?.forEach((entry) => {
      const existing = map.get(entry.memberId) || [];
      existing.push(entry);
      map.set(entry.memberId, existing);
    });

    const groups: MemberGroup[] = [];
    map.forEach((entries, memberId) => {
      let totalMinutes = 0;
      entries?.forEach((e) => {
        totalMinutes +=
          (e?.effort?.hours || 0) * 60 + (e?.effort?.minutes || 0);
      });

      groups.push({
        memberId,
        entries,
        totalHours: Math.floor(totalMinutes / 60),
        totalMinutes: totalMinutes % 60,
      });
    });

    return groups;
  }, [effortActual]);

  return (
    <>
      {groupedByMember.map((group) => (
        <MemberEntryGroup
          key={group.memberId}
          group={group}
          selectedTicketDetails={selectedTicketDetails}
        />
      ))}
    </>
  );
};

export default TimeEntryItem;
